import { IcStatusLosange } from '@assets/icons/24x24';
import {
  createListCollection,
  Field as ChakraField,
  Fieldset,
  HStack,
  Icon,
  Input,
  Text,
  VStack,
} from '@chakra-ui/react';
import { CockpitFormLayout } from '@components/cockpit/layouts/CockpitFormLayout';
import ModifiedTag from '@components/common/form/ModifiedField';
import RequiredIndicator from '@components/ui/RequiredIndicator';
import { CustomSelect } from '@components/ui/select/Select';
import { getClearanceColor } from '@utils/data/notification.utils';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';

import { DroneClearanceEnum } from '@/types/utm/drone.types';
import { NormalizedFleet } from '@/types/utm/fleet.type';

export default function FleetGeneralTab() {
  const { formatMessage } = useIntl();
  const { errors, touched, initialValues, values, setFieldValue } = useFormikContext<NormalizedFleet>();

  return (
    <CockpitFormLayout title="components.utm.fleets.tab.general.title">
      <Fieldset.Root invalid={Object.keys(errors).some((key) => touched[key as keyof typeof touched])}>
        <VStack width="100%" gap={5} alignItems="start">
          <ChakraField.Root variant="cockpit" required invalid={touched.name && !!errors.name}>
            <ChakraField.Label width="100%" height="20px">
              <FormattedMessage id="components.utm.fleets.name" />
              <ChakraField.RequiredIndicator />
              {initialValues.name !== values.name && <ModifiedTag />}
            </ChakraField.Label>
            <Field as={Input} type="text" name="name" id="name" />
          </ChakraField.Root>
          <Fieldset.Root invalid={Object.keys(errors).some((key) => touched[key as keyof typeof touched])}>
            <ChakraField.Root
              variant="cockpit"
              required
              invalid={touched.strategicClearance && !!errors.strategicClearance}
            >
              <ChakraField.Label width="100%" height="20px">
                <FormattedMessage id="components.utm.fleets.tab.general.strategicClearance" />
                <RequiredIndicator />
                {initialValues.strategicClearance !== values.strategicClearance && <ModifiedTag />}
              </ChakraField.Label>
              <CustomSelect
                value={values.strategicClearance}
                clearable
                collection={createListCollection({
                  items: Object.values(DroneClearanceEnum).map((clearance) => ({
                    label: formatMessage({ id: `clearance.${clearance}` }),
                    value: clearance,
                  })),
                })}
                formatLabel={(option) => (
                  <HStack gap={1.5}>
                    <Icon as={IcStatusLosange} boxSize="24px" color={getClearanceColor(option.value)} />
                    <Text width="100%">{option.label}</Text>
                  </HStack>
                )}
                onChange={(value) => setFieldValue('strategicClearance', value)}
              />
            </ChakraField.Root>
          </Fieldset.Root>
        </VStack>
      </Fieldset.Root>
    </CockpitFormLayout>
  );
}
